import { useAuth, useClerk } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
  url: string;
};

export function CrmV3SignUpRedirect({ url }: Props) {
  const clerk = useClerk();
  const { isLoaded } = useAuth();
  const { search, hash } = useLocation();

  useEffect(() => {
    if (!isLoaded) return;
    // Staging's Clerk development instance needs the session in the URL; production returns it unchanged.
    window.location.replace(clerk.buildUrlWithAuth(`${url}${search}${hash}`));
  }, [clerk, isLoaded, url, search, hash]);

  return (
    <div className="flex h-screen items-center justify-center">
      <Loader2 className="text-muted-foreground h-8 w-8 animate-spin" />
    </div>
  );
}
